/* =====================================================================
   SH4DE — promos : ancien prix barré + « Tu économises » dans le tiroir
   panier, la page panier et la page catalogue.
   Données : #v2-promo-data (site-header) =
   { v: { idVariante: [prix, prixBarré] }, h: { handle: [prix, prixBarré] } }
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var data = { v: {}, h: {} };
  try {
    var src = doc.getElementById('v2-promo-data');
    if (src) data = JSON.parse(src.textContent);
  } catch (e) {}
  data.v = data.v || {};
  data.h = data.h || {};

  var TAG = `<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z'/><circle cx='7.5' cy='7.5' r='1.5'/></svg>`;

  function money(c) {
    c = Math.round(Number(c) || 0);
    return (c / 100).toLocaleString('fr-FR', {
      style: 'currency', currency: 'EUR',
      minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2
    });
  }
  function cents(t) {
    var s = String(t || '').replace(/[^\d.,]/g, '');
    if (s.indexOf(',') > -1) s = s.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  var T = function (k, d) { return window.SH4DE_T ? window.SH4DE_T(k, d) : d; };
  function saveHTML(amount, after) {
    return TAG + `<span>` + T('save', 'Tu économises') + ` <b>` + money(amount) + `</b>` + (after ? ' ' + after : '') + `</span>`;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ------------------------------------------------------------------
     Tiroir panier
  ------------------------------------------------------------------ */
  function decorateDrawer() {
    var drawer = doc.getElementById('CartDrawer');
    if (!drawer) return;
    var save = 0;

    each(drawer.querySelectorAll('#CartItems .cart-line'), function (line) {
      var a = line.querySelector('.v2-line__img');
      var m = /[?&]variant=(\d+)/.exec((a && a.getAttribute('href')) || '');
      var d = m && data.v[m[1]];
      if (!d) return;
      var q = parseInt((line.querySelector('[data-qty-val]') || {}).textContent, 10) || 1;
      save += (d[1] - d[0]) * q;
      var pr = line.querySelector('.v2-line__price');
      if (pr && !pr.querySelector('.v2-line__old')) {
        pr.classList.add('is-sale');
        pr.insertAdjacentHTML('afterbegin', `<s class='v2-line__old'>` + money(d[1] * q) + `</s>`);
      }
    });

    var foot = drawer.querySelector('[data-v2-foot]');
    var tot = drawer.querySelector('.v2-drawer__total');
    var totalEl = doc.getElementById('CartTotal');
    if (foot && tot) {
      var box = foot.querySelector('.v2-drawer__save');
      if (!box) {
        box = doc.createElement('p');
        box.className = 'v2-drawer__save';
        foot.insertBefore(box, tot);
      }
      var old = tot.querySelector('.v2-total-old');
      if (!old && totalEl && totalEl.parentNode === tot) {
        old = doc.createElement('s');
        old.className = 'v2-total-old';
        tot.insertBefore(old, totalEl);
      }
      if (save > 0) {
        box.innerHTML = saveHTML(save, T('on_order', 'sur ta commande'));
        box.hidden = false;
        if (old) old.textContent = totalEl ? money(cents(totalEl.textContent) + save) : '';
      } else {
        box.hidden = true;
        if (old) old.textContent = '';
      }
    }

    // Produit proposé en complément : prix barré + prix promo
    var dup = drawer.querySelector('.v2-dup');
    if (dup && !dup.querySelector('.v2-was')) {
      var link = dup.querySelector('.v2-dup__img');
      var hm = /\/products\/([^\/?#]+)/.exec((link && link.getAttribute('href')) || '');
      var hd = hm && data.h[hm[1]];
      var b = dup.querySelector('.v2-dup__t b');
      var txt = b && b.nextSibling;
      if (hd && txt && txt.nodeType === 3) {
        txt.textContent = ' · ';
        var now = doc.createElement('span');
        now.className = 'v2-now';
        now.textContent = money(hd[0]);
        var was = doc.createElement('s');
        was.className = 'v2-was';
        was.textContent = money(hd[1]);
        txt.parentNode.insertBefore(now, txt.nextSibling);
        txt.parentNode.insertBefore(was, now);
      }
    }
  }

  var pending = false;
  function queue() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; decorateDrawer(); }, 0);
  }
  if ('MutationObserver' in window) {
    ['CartItems', 'CartUpsell', 'CartTotal'].forEach(function (id) {
      var n = doc.getElementById(id);
      if (n) new MutationObserver(queue).observe(n, { childList: true });
    });
  }
  decorateDrawer();

  /* ------------------------------------------------------------------
     Page panier (/cart)
  ------------------------------------------------------------------ */
  var page = doc.querySelector('.sh4de-cart-page');
  if (page) {
    var psave = 0;
    each(page.querySelectorAll('.cart-line'), function (line) {
      var inp = line.querySelector('.cart-line-input');
      var m = inp && /updates\[(\d+)/.exec(inp.getAttribute('name') || '');
      var d = m && data.v[m[1]];
      if (!d) return;
      var q = parseInt(inp.value, 10) || 1;
      psave += (d[1] - d[0]) * q;
      var pr = line.querySelector('.cart-line-price');
      if (pr) {
        pr.classList.add('is-sale');
        pr.insertAdjacentHTML('afterbegin', `<s class='v2-line__old'>` + money(d[1] * q) + `</s>`);
      }
    });
    var sum = page.querySelector('.cart-summary');
    if (psave > 0 && sum) sum.insertAdjacentHTML('afterbegin', `<p class='v2-drawer__save v2-cart-save'>` + saveHTML(psave, T('on_order', 'sur ta commande')) + `</p>`);
  }

  /* ------------------------------------------------------------------
     Page catalogue
  ------------------------------------------------------------------ */
  each(doc.querySelectorAll('.cg-info'), function (info) {
    var cur = info.querySelector('.cg-price .current');
    var cmp = info.querySelector('.cg-price .compare');
    if (!cur || !cmp || info.querySelector('.v2-pr__save')) return;
    var s = cents(cmp.textContent) - cents(cur.textContent);
    if (s > 0) info.insertAdjacentHTML('beforeend', `<span class='v2-pr__save v2-cg-save'>` + saveHTML(s) + `</span>`);
  });
})();
